<template>
  <div class="container-fluid w-100" style="overflow: hidden">
    <navbar v-if="!editMode" :title="$t('contracts.contract_class.title_plural')" />
    <Transition name="fade">
      <contract-class-list
        v-if="!editMode"
        :results="results"
        @add="addNew"
        @edit="edit"
      />
    </Transition>

    <base-modal v-if="editMode" hide-header hide-footer size="lg" @close="editMode = false; contractClass = null">
        <contract-class-editor
          ref="contractClassEditor"
          :contract-class="contractClass"
          :contract-classes="results"
          @close="showList"
          @close-and-update="closeAndUpdate"
        />
    </base-modal>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import ContractClassList from "@/components/contract/class/ContractClassList";
import ContractClassEditor from "@/components/contract/class/ContractClassEditor";
import Navbar from "@/components/utils/Navbar.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'ContractClasses',
    components: {BaseModal, Navbar, ContractClassEditor, ContractClassList},
    mixins: [restApi],
    data: function () {
        return {
            results: [],
            contractClass: null,
            editMode: false,
            loading: false
        }
    },
    mounted: function () {
        this.fetchContractClasses()
    },
    methods: {
        fetchContractClasses: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.contractClassUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        addNew: function () {
            this.contractClass = {id: null, name: null, type: null, in_use: true}
            this.editMode = true
        },
        edit: function (contractClass) {
            this.contractClass = contractClass
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchContractClasses()
            this.showList()
        }

    }
}
</script>
